import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class StudentExamDataService {
  registrationNumber = new BehaviorSubject<string>('');
  studentName = new BehaviorSubject<string>('');
  canLoad = new BehaviorSubject<boolean>(false);
  examReportId = new BehaviorSubject<string>('');
}
